module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Zunzgen-95b3d0c2042e8fd6fdcba09c0a5c1bd3.svg";